/*
 * IPA2GO Flooring Shop Customization
 * By Dave Lazar, Resistor Software Inc. 
 * (c) October 2012
 */


if (typeof(console) == 'undefined') {
    var console = {
        log: function () {},
        info: function () {},
        warn: function () {},
        error: function () {},
        time: function () {}
    };
}
else if (typeof(console.log) == 'undefined') {
    console.log = function () {};
}

if(!Ipa2Go) {
  var Ipa2Go = {};
}

Ipa2Go.utils = function () {
  var products = [];
  var product;
  var variant;
  var cart = [];
  var carton_sqft = 0.0;
  var variantCoverage = {};           // this hash contains a float representing how many square feet a box covers
  var variantPallets = {};
  
  return {

    getVariant : function() {
      return variant;
    },

    setVariant : function(v) {
      variant = v;
    },

    getVariantCoverage : function(id) {
      return variantCoverage[id];
    },

    setVariantCoverage : function(id, area) {
      variantCoverage[id] = area;
    },
    
    getVariantPallets : function(id) {
      return variantPallets[id];
    },

    setVariantPallets : function(id, pallets) {
      variantPallets[id] = pallets;
    },

    setProduct : function(p) {
      product = p;
    },

    getProduct : function() {
      return product;
    },

    getCartonSqFt : function () {
      return carton_sqft;
    },

    setCartonSqFt : function(sqft) {
      carton_sqft = sqft;
    },

    getProducts : function () {
      return products;
    },

    getCart : function() {
      return cart;
    }

  }

}();

// add to plugins here
(function ($) {
  
})(jQuery);

// DOM is ready
$(function () {
  
  $('#loading').ajaxStart(function() {
    $(this).show();
  });
     
  $('#loading').ajaxStop(function() {
    $(this).hide();
  });

});